import ipPrivate from 'private-ip';

const isIpPrivate = ip => ipPrivate(ip);

export default isIpPrivate;



// WEBPACK FOOTER //
// ./app/utils/ipAddress.js